"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelPersonalizeFooter = void 0;

var _atoms = require("../../../atoms");

var _Tracker = require("../../../util/Tracker");

var _molecules = require("../../../molecules");

require("./CancelPersonalizeFooter.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Cancel Personalize Footer
var CancelPersonalizeFooter = function CancelPersonalizeFooter(_ref) {
  var onAbortCancelClick = _ref.onAbortCancelClick,
      onConfirmCancelClick = _ref.onConfirmCancelClick;

  var handleOnAbortCancelClick = function handleOnAbortCancelClick(e) {
    if (typeof onAbortCancelClick === "function") {
      (0, _Tracker.trackEvent)({
        action: "Step Button Abort Cancel Create & Save Pressed",
        element: e.currentTarget
      });
      onAbortCancelClick();
    }
  };

  var handleOnConfirmCancelClick = function handleOnConfirmCancelClick(e) {
    if (typeof onConfirmCancelClick === "function") {
      (0, _Tracker.trackEvent)({
        action: "Step Button Confirm Cancel Pressed",
        element: e.currentTarget
      });
      onConfirmCancelClick();
    }
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "FooterSection CancelPersonalizeFooter"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    justifyContent: "center",
    className: "cancel-personalize-footer-inner"
  }, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    marginRight: "1",
    onClick: handleOnAbortCancelClick,
    className: "button-abort-cancel",
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: "No, don't cancel"
    }))
  }), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: true,
    marginLeft: "1",
    onClick: handleOnConfirmCancelClick,
    className: "button-confirm-cancel",
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: "Yes, cancel"
    }))
  })));
};

exports.CancelPersonalizeFooter = CancelPersonalizeFooter;